import { Component, OnDestroy, inject } from '@angular/core';
import { ChatStateService } from '../../../features/chat/services/chat-state.service';
import { MessageComposer } from '../../components/message-composer/message-composer';
import { MessageList } from '../../components/message-list/message-list';
import { ClipboardService } from '../../../shared/services/clipboard.service';
import { SettingsService } from '../../../features/settings/services/settings.service';

@Component({ selector: 'app-chat-page', standalone: true, imports: [MessageComposer, MessageList], templateUrl: './chat-page.html', host: { class: 'flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden' } })
export class ChatPage implements OnDestroy {
  protected readonly state = inject(ChatStateService); protected readonly settings = inject(SettingsService); private readonly clipboard = inject(ClipboardService);
  protected copy(value: string): void { void this.clipboard.write(value); }
  ngOnDestroy(): void { this.state.cancelSend(); }
}
